import {
  StyledContent,
  StyledList,
  StyledRoot,
  StyledTrigger,
} from 'components/atomic/atoms/tabs/tabs.styled'

export const Tabs = StyledRoot
export const TabsList = StyledList
export const Tab = StyledTrigger
export const TabContent = StyledContent
